<template>
  <div>
    <svg t="15087387012231" @click='click' class="close-svg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
         p-id="20119" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height">
      <path d="M521.693867 449.297067L111.4112 39.0144a51.2 51.2 0 1 0-72.430933 72.362667l410.282666 410.3168-410.282666 410.3168a51.2 51.2 0 1 0 72.3968 72.3968l410.3168-410.282667 410.3168 410.282667a51.2 51.2 0 1 0 72.3968-72.362667l-410.282667-410.350933 410.282667-410.282667a51.2 51.2 0 1 0-72.3968-72.3968l-410.282667 410.282667z"
            p-id="2071110"></path>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'close',
    props: {
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: Number,
        default: 24
      },
      fill: {
        type: String,
        default: '#48576a'
      }
    },
    data() {
      return {
        isFullscreen: false
      }
    },
    methods: {
      click() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()// In order to re-instantiate the vue-router object to avoid bugs
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Close/index.vue